__turbopack_context__.v({
  "canvas": "gS_W1W_canvas",
  "canvasContainer": "gS_W1W_canvasContainer",
  "description": "gS_W1W_description",
  "heading": "gS_W1W_heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "section": "gS_W1W_section",
  "textContainer": "gS_W1W_textContainer",
});
